import { Component } from 'react';
import { shuffle } from '../../../utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIList from 'UIComponents/list/UIList';
import UISelectableButton from 'UIComponents/button/UISelectableButton';
import { mapRedirectTargetToRoute, mapRedirectTargetToRouteFromApiName } from 'self-service-api/core/utilities/links';
import { getProductNameText, getProductNameTextFromApiName } from '../../common/adapters/getProductNameText';
import TrialRedirectSurvey from './TrialRedirectSurvey';
import * as tracker from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import SuccessModal from '../../common/components/activation/SuccessModal';
import { navigateTo } from '../../common/navigation/url';
import { getUpgradeDataTrackingProperties } from 'ui-addon-upgrades/ums/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LANG_ROUTE = 'upgrades.activationModal.new';
const OPTIONS = {
  CREATE_NEW_USERS: 'createNewUsers',
  SPECIFIC_FEATURE: 'specificFeature',
  EXPLORE_ON_YOUR_OWN: 'exploreOnYourOwn'
};
const shuffledOptions = shuffle(Object.values(OPTIONS));
class TrialActivationNextStepsModal extends Component {
  constructor(props) {
    super(props);
    this.handleOptionClick = option => {
      const {
        upgradeData,
        upgradeData: {
          upgradeProduct,
          apiName
        }
      } = this.props;
      const trackingProperties = Object.assign({}, getUpgradeDataTrackingProperties(upgradeData), {
        trialId: upgradeData.trialId,
        duration: upgradeData.duration
      });
      switch (option) {
        case OPTIONS.CREATE_NEW_USERS:
          tracker.trackBeforeUnload('trialActivationInteraction', Object.assign({
            action: 'clicked create new users'
          }, trackingProperties));
          if (apiName) {
            navigateTo(mapRedirectTargetToRouteFromApiName('user-settings'));
          } else {
            navigateTo(mapRedirectTargetToRoute('user-settings'));
          }
          break;
        case OPTIONS.SPECIFIC_FEATURE:
          tracker.track('trialActivationInteraction', Object.assign({
            action: 'clicked try out a specific feature'
          }, trackingProperties));
          this.setState({
            showRedirectSurvey: true
          });
          break;
        case OPTIONS.EXPLORE_ON_YOUR_OWN:
          tracker.trackBeforeUnload('trialActivationInteraction', Object.assign({
            action: 'clicked explore on my own'
          }, trackingProperties));
          if (apiName) {
            navigateTo(mapRedirectTargetToRouteFromApiName('other', apiName));
          } else {
            navigateTo(mapRedirectTargetToRoute('other', upgradeProduct));
          }
          break;
        default:
          break;
      }
    };
    this.state = {
      showRedirectSurvey: false
    };
  }
  render() {
    const {
      upgradeData: {
        upgradeProduct,
        apiName
      },
      upgradeData
    } = this.props;
    const {
      showRedirectSurvey
    } = this.state;
    const productName = apiName ? getProductNameTextFromApiName(apiName) : getProductNameText(upgradeProduct);
    if (showRedirectSurvey) {
      return /*#__PURE__*/_jsx(SuccessModal, {
        header: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${LANG_ROUTE}.redirectModal.header`
        }),
        footer: /*#__PURE__*/_jsx(TrialRedirectSurvey, {
          upgradeData: upgradeData
        })
      });
    }
    return /*#__PURE__*/_jsx(SuccessModal, {
      header: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${LANG_ROUTE}.successModal.thanksForActivatingTrial`
      }),
      footer: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: `${LANG_ROUTE}.successModal.subHeader`,
          options: {
            productName
          }
        }), /*#__PURE__*/_jsxs("div", {
          className: "text-left m-top-6",
          style: {
            width: '100%'
          },
          children: [/*#__PURE__*/_jsx("h5", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `${LANG_ROUTE}.successModal.firstAction`
            })
          }), /*#__PURE__*/_jsx(UIList, {
            children: shuffledOptions.map(option => /*#__PURE__*/_jsx(UISelectableButton, {
              className: "m-bottom-2 display-inline-block text-left",
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `${LANG_ROUTE}.successModal.actions.${option}`
              }),
              block: true,
              name: "other",
              truncatable: false,
              onClick: () => this.handleOptionClick(option)
            }, option))
          })]
        })]
      })
    });
  }
}
export default TrialActivationNextStepsModal;